<template>
  <v-btn icon small @click="$emit('change')" color="white" :class="classAttr" :style="extraStyle">
    <v-icon small>{{this.icon}}</v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: 'ActionBtnTwo',
    props: ['isOpen', 'isChanged', 'noData'],
    computed: {
      icon () {
        if (this.noData) {
          return 'mdi-cancel'
        }
        return this.isOpen ? 'mdi-check' : 'mdi-close'
      },
      extraStyle () {
        return this.isChanged ? 'border: 1px dashed black !important;' : ''
      },
      classAttr () {
        let classAttr = ''
        if (this.noData) {
          classAttr = 'grey darken-3'
        } else {
          classAttr = this.isOpen ? 'green lighten-2' : 'red lighten-1'
        }
        if (this.isChanged) {
          classAttr += ''
        }
        return classAttr
      }
    }
  }
</script>
